// extracted by mini-css-extract-plugin
export var bottomRightDock = "_30-0";